import {
  PRE_PREPARATION_TIME_CHOSEN,
  PRE_CREATE_ORDER_AND_USER,
  PRE_FETCH_PRODUCTS_CART,
  INIT_FUNCTION_PAYMENT,
  CALL_FUNCTION_PAYMENT,
  SEND_SESSION_PAY_PLUS,
  PRE_FETCH_ORDER_DATA,
  CALL_CALCUL_HOUR,
  INIT_CALCUL_HOUR,
  PRE_CREATE_ORDER,
  PRE_ADD_COMMENTS,
  PRE_SEND_ORDER,
  INIT_ORDER,
  RESET_ORDER_TIME,
} from "../types/order.types";

export function createOrderAndUser(id_restaurant) {
  return { type: PRE_CREATE_ORDER_AND_USER, id_restaurant };
}

export function fetchProductsInCart(id_order, id_restaurant) {
  return { type: PRE_FETCH_PRODUCTS_CART, id_order, id_restaurant };
}

export function createOrder(id_restaurant, id_user) {
  return { type: PRE_CREATE_ORDER, id_restaurant, id_user };
}

export function sendOrder(id_order) {
  return {
    type: PRE_SEND_ORDER,
    id_order,
  };
}

export function callFunctionPayment() {
  return { type: CALL_FUNCTION_PAYMENT };
}

export function initFunctionPayment() {
  return { type: INIT_FUNCTION_PAYMENT };
}

export function addComments(text_value, id_order) {
  return { type: PRE_ADD_COMMENTS, text_value, id_order };
}

export function preparationTimeChosen(time_stamps, id_order) {
  return { type: PRE_PREPARATION_TIME_CHOSEN, time_stamps, id_order };
}

export function callCalculateHour() {
  return { type: CALL_CALCUL_HOUR };
}

export function initCalculateHour() {
  return { type: INIT_CALCUL_HOUR };
}

export function sendSessionPayPlus(session) {
  return {
    type: SEND_SESSION_PAY_PLUS,
    session,
  };
}

export function fetchOrderData(id_order, id_restaurant) {
  return {
    type: PRE_FETCH_ORDER_DATA,
    id_restaurant,
    id_order,
  };
}
export function initOrder() {
  return {
    type: INIT_ORDER,
  };
}
export function resetOrderTime() {
  return {
    type: RESET_ORDER_TIME,
  };
}
